import { Voice } from 'types';

import { isV3Voice } from './v3Voices';

const DEFAULT_VOICE_ID = 'tnSpp4vdxKPjI9w0GnoV';

/**
 * The ready-made voice list. Browsers cache it for an hour and Vercel's CDN
 * for a day (see /api/list-voices), so bump `v` whenever the response gains
 * something the picker needs: a new URL is fetched fresh everywhere.
 * v=2: gender, age, use case and tone from public.catalog_voices.
 * v=3: other_languages (languages ElevenLabs verified each voice for).
 */
export const VOICE_LIST_URL = '/api/list-voices?v=3';

/**
 * Lightweight default voice used for the TTS page's initial render so the page
 * does not need to import the full ~25k-line VOICES constant into the client
 * bundle. The complete preset list is fetched at runtime from
 * `/api/list-voices`.
 */
export const DEFAULT_VOICE: Voice = {
  voice_id: DEFAULT_VOICE_ID,
  name: 'Hope',
  category: 'professional',
  labels: { use_case: 'Social Media' },
  description:
    'Upbeat and clear young American female voice. Great for social media content.',
  image: 'hope-american.webp',
  preview_url:
    'https://storage.googleapis.com/eleven-public-prod/custom/voices/tnSpp4vdxKPjI9w0GnoV/LiIyxRT1qFJ1QJPr8sWl.mp3',
  language: 'English',
  accent: 'American',
  gender: 'female',
  age: 'young',
  use_case: 'social_media',
  tone: 'upbeat',
  // Derive the flag from the allow-list so the initial render matches the
  // picker.
  ...(isV3Voice(DEFAULT_VOICE_ID) ? { expressive: true } : {}),
};
